import React from 'react';
import HeroSection from '../components/common/HeroSection';
import Goals from '../components/foundation/Goals';

const breadcrumb = [
  { key: 'nav.home',    path: '/' },
  { key: 'nav.ourGoal', path: null },
];

const OurGoal = () => (
  <>
    <HeroSection
      titleKey="goals.title"
      subtitleKey="goals.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <Goals />
  </>
);

export default OurGoal;
